import React from "react";
import TagBadge, { tagBadgeColor, tagName } from "./TagBadge";

const PeopleTags = ({ tags = [], selectedTagId, onSelect, language }) => {
  if (!tags.length) {
    return null;
  }

  return (
    <div className="flex justify-center flex-wrap items-center gap-1">
      {tags.map((tag) => {
        const isSelected = tag.id === selectedTagId;

        return (
          <TagBadge
            key={tag.id}
            component="button"
            type="button"
            radius="md"
            size="md"
            className={`cursor-pointer ${isSelected ? "ring-2 ring-white/90" : ""}`}
            color={tagBadgeColor(tag.name, tag.type)}
            variant={isSelected ? "filled" : "light"}
            onClick={() => onSelect(tag)}
            onMouseDown={() => onSelect(tag)}
          >
            <div className="flex items-center text-center gap-1">
              {tag.imgUrl && (
                <img
                  className="w-5 max-w-none h-5 rounded-full"
                  src={tag.imgUrl}
                  alt={tag.name}
                />
              )}
              <span>{tagName(tag.name, language)}</span>
            </div>
          </TagBadge>
        );
      })}
    </div>
  );
};

export default PeopleTags;
